import React from "react";
import { inject, observer } from "mobx-react";
import { FormRow, Option, RadioGroup } from "@op/opds.opux";
import { useMessageGetter } from "react-message-context";
import { CONTACT_METHODS } from "../../../utils/enums";
import withAnimation from "../../../utils/withAnimation";
import { useUpdateIncluded } from "../../../utils/commonUtils";

const ContactMethod = observer(({ customerType, FeedbackStore }) => {
  const key = "contactMethod";
  const { feedback, updateValue, updateIncluded } = FeedbackStore;
  const contactMethod = feedback.contactMethod;
  const options = CONTACT_METHODS[customerType];
  const msgs = useMessageGetter("feedback.form.contactMethod");

  // Update included property when contactCustomer field's value changes
  useUpdateIncluded(key, feedback.contactCustomer.value, updateIncluded);

  // Select first option by default if value is empty
  if (!contactMethod.value) updateValue(key, options[0]);

  const handleOnChange = (value) => {
    updateValue(key, value);
  };

  return (
    <div className="cff-contactMethod">
      <FormRow
        label={msgs("label")}
        labelFor={`CFF-${key}`}
        labelId={`cff-contactMethod`}
      >
        <RadioGroup
          id={`CFF-${key}`}
          name={key}
          value={contactMethod.value}
          onChange={(_e, val) => handleOnChange(val)}
          aria-required={true}
        >
          {options.map((option) => (
            <Option id={`CFF-${key}-${option}`} key={option} value={option}>
              {msgs(`options.${option}`)}
            </Option>
          ))}
        </RadioGroup>
      </FormRow>
    </div>
  );
});

export default withAnimation(inject("FeedbackStore")(ContactMethod));
export const ContactMethodNoAnimation = inject("FeedbackStore")(ContactMethod);
